import type { DecideLoginAssuranceInput, LoginAssuranceDecision } from './deviceBridge.types';

export function decideLoginAssuranceAction(input: DecideLoginAssuranceInput): LoginAssuranceDecision {
  if (input.hiddenByFailure) {
    return noneDecision('hidden_after_failure');
  }

  if (input.passkeyEnabled && input.hasLocalPasskey && input.hasDesktopPasskeys) {
    return {
      action: 'local_passkey',
      label: input.context === 'desktop' ? 'Entrar com biometria' : 'Biometria digital',
      usesDesktopPasskey: true,
      usesMobileApproval: false,
      reason: 'local_passkey_available',
    };
  }

  if (input.context === 'desktop' && input.hasMobileApproval && input.hasPushToken) {
    return {
      action: 'mobile_approval',
      label: 'Autorizar pelo celular',
      usesDesktopPasskey: false,
      usesMobileApproval: true,
      reason: 'desktop_can_request_mobile_approval',
    };
  }

  return noneDecision(
    input.context === 'desktop'
      ? 'no_desktop_passkey_or_mobile_approval'
      : 'mobile_does_not_request_mobile_approval',
  );
}

function noneDecision(reason: string): LoginAssuranceDecision {
  return {
    action: 'none',
    label: '',
    usesDesktopPasskey: false,
    usesMobileApproval: false,
    reason,
  };
}
